__turbopack_context__.v({
  "itemArrow": "TrendArrow-module__U5OccG__itemArrow",
  "negative": "TrendArrow-module__U5OccG__negative",
  "positive": "TrendArrow-module__U5OccG__positive",
});
